export const INK = {
  text: '#1d2939',
  body: '#344054',
  muted: '#667085',
  border: '#e4e7ec',
  divider: '#eaecf0',
  control: '#d0d5dd',
  tint: '#eef2ff',
  primary: '#465fff',
  danger: '#b42318',
  dangerBorder: '#fecdca',
  thread: '#f9fafb',
} as const;

export const OFFER_BORDER = '#fedf89';
export const OFFER_BG = '#fffaeb';

export const PROOF_COLORS = {
  requested: { color: '#175cd3', borderColor: '#b2ddff', bgcolor: '#eff8ff' },
  sent: { color: '#067647', borderColor: '#abefc6', bgcolor: '#ecfdf3' },
} as const;

export const BUTTON = {
  textTransform: 'none',
  fontSize: 13,
  fontWeight: 600,
  borderRadius: '8px',
  px: '14px',
  boxShadow: 'none',
  whiteSpace: 'nowrap',
} as const;

export const OUTLINED = { ...BUTTON, color: INK.body, borderColor: INK.control, bgcolor: '#fff' } as const;

export const DIALOG = {
  width: 560,
  maxWidth: 'calc(100% - 32px)',
  m: 2,
  p: 3,
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  color: INK.text,
} as const;

export const FIELD_LABEL = { display: 'block', fontSize: 12, color: INK.muted, mb: '4px' } as const;

export const FIELD = { '& .MuiInputBase-root': { fontSize: 13, borderRadius: '8px' } } as const;

export const pill =(on: boolean) => ({
  height: 28,
  flexShrink: 0,
  borderRadius: '14px',
  fontSize: 12,
  bgcolor: on ? INK.tint : '#fff',
  borderColor: on ? INK.primary : INK.control,
  color: on ? INK.primary : INK.body,
  '& .MuiChip-label': { px: '10px' },
  '&&:hover': { bgcolor: on ? INK.tint : INK.thread },
});
